module.exports = __webpack_public_path__ + "img/katarina10.9f77dd46.jpg";